import { render, staticRenderFns } from "./CustomerAdvisoryBoard.vue?vue&type=template&id=f470d4a2&"
import script from "./CustomerAdvisoryBoard.vue?vue&type=script&lang=js&"
export * from "./CustomerAdvisoryBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports